import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";

import "./HomeSlider.scss";
import { sliderData } from "../../constants/SliderData/sliderData";

const HomeSlider = () => {
  return (
    <div className="home-slider" dir="ltr">
      <Swiper
        modules={[Autoplay, EffectFade, Pagination]}
        effect="fade"
        fadeEffect={{ crossFade: true }}
        speed={800}
        loop={true}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        }}
        pagination={{
          clickable: true,
          el: ".home-slider__dots",
          bulletClass: "home-slider__dot",
          bulletActiveClass: "home-slider__dot--active",
        }}
        className="home-slider__swiper"
      >
        {sliderData.map((slide, index) => (
          <SwiperSlide key={slide.id || index}>
            <div className="home-slider__slide">
              <img
                src={slide.src}
                alt={slide.title || `Slide ${index + 1}`}
                className="home-slider__image"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Dots */}
      <div className="home-slider__dots-container">
        <div className="home-slider__dots"></div>
      </div>
    </div>
  );
};

export default HomeSlider;
